import { create } from 'zustand';

import { langs } from '../translations/langs';

import type { LocaleType } from '../@types';

type State = {
  translations: Record<string, string>;
};

type Action = {
  t: (key: string) => string;
  fetchTranslations: (locale: LocaleType) => void | Promise<void>;
};

export const useTranslations = create<State & Action>()((set, get) => ({
  translations: {},
  t: (key: string) => get().translations[key] ?? key,
  fetchTranslations: async (locale: LocaleType) => {
    const defaults = langs.en_us;
    const data = langs[locale.toLowerCase()] || {};

    const translations = {
      ...defaults,
      ...data,
    };
    set(() => ({ translations }));
  },
}));
